import { Box, Container, Flex } from '@energiebespaarders/symbols';
import { Heading } from '@energiebespaarders/symbols/helpers';
import mediaMin from '@energiebespaarders/symbols/styles/breakpoints';
import Link from 'next/link';
import { rgba } from 'polished';
import styled from 'styled-components';
import LoginForm from './LoginForm';
import HandshakeImg from '/public/img/envPartner/handshake-min.jpg'; /* original img path: './img/handshake-min.jpg'; */
import DEBLogoWhite from '/public/img/logo_WEB_white.svg'; /* original path: '/public/img/logo_WEB_white.svg'; */

const StyledSamenHero = styled.div`
  position: relative;
  width: 100%;
  min-height: 600px;
  background: ${x =>
    `linear-gradient(to bottom, ${rgba(x.theme.colors.green, 0.9)}, ${rgba(
      x.theme.colors.blue,
      0.9,
    )}), url(${HandshakeImg})`};
  color: white;
  background-size: 100%, cover;
  background-position:
    center,
    top left;
  border-bottom-left-radius: 60px;

  ${mediaMin.md} {
    border-bottom-left-radius: 90px;
  }

  ${mediaMin.lg} {
    border-bottom-left-radius: 120px;
  }

  ${mediaMin.xl} {
    border-bottom-left-radius: 180px;
  }
`;

const StyledHomeLink = styled.a`
  position: absolute;
  top: 15px;
  left: 15px;
  color: white;
  font-size: ${x => x.theme.type.scale[6]};

  &:hover {
    color: white;
    font-weight: 600;
  }
`;

const StyledLogo = styled.img`
  max-width: 320px;
`;

const StyledHeading = styled(Heading)`
  line-height: 1.1;
`;

const SamenHero = () => {
  return (
    <StyledSamenHero>
      <Link href="/" passHref>
        <StyledHomeLink>← Terug naar homepage</StyledHomeLink>
      </Link>
      <Container color="white">
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          py={10}
          style={{ gap: 30 }}
        >
          <Box>
            <Link href="/" passHref>
              <a>
                <StyledLogo src={DEBLogoWhite} title="Naar de homepage" />
              </a>
            </Link>
          </Box>
          <Box>
            <StyledHeading heading="h1" color="white">
              Welkom bij Samen
            </StyledHeading>
          </Box>
          <Box>
            <LoginForm />
          </Box>
        </Flex>
      </Container>
    </StyledSamenHero>
  );
};

export default SamenHero;
